var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgView(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12 .04c6.524 0 11.633 6.887 11.847 7.18.204.279.204.656 0 .935-.214.293-5.323 7.18-11.847 7.18-6.525 0-11.634-6.887-11.848-7.18-.203-.279-.203-.656 0-.935C.366 6.927 5.475.04 12 .04zm0 1.582c-4.816 0-8.97 4.569-10.2 6.065C3.03 9.182 7.193 13.753 12 13.753c4.816 0 8.97-4.57 10.2-6.065-1.232-1.495-5.394-6.066-10.2-6.066zm0 1.318c2.617 0 4.747 2.13 4.747 4.747 0 2.618-2.13 4.748-4.747 4.748-2.618 0-4.747-2.13-4.747-4.748C7.253 5.07 9.383 2.94 12 2.94zm0 1.583c-1.745 0-3.165 1.42-3.165 3.165s1.42 3.164 3.165 3.164 3.165-1.42 3.165-3.165S13.745 4.524 12 4.524z",
    transform: "translate(-526 -105) translate(106 94) translate(0 6) translate(420 5)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.065d516c.svg";
export { ForwardRef as ReactComponent };